import { useCallback, useMemo } from 'react';
import { useClerk, useUser } from '@clerk/clerk-react';
const isClerkAvailable = typeof window !== 'undefined' && !!(process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || process.env.CLERK_PUBLISHABLE_KEY);
const SIGN_OUT_TOAST_KEY = 'swim-lab:pending-toast';
const noopAuthAdapter = {
    isLoaded: true,
    isSignedIn: false,
    user: null,
    signIn: async () => undefined,
    signOut: async () => undefined,
};
export function useAuthAdapter() {
    if (!isClerkAvailable) {
        console.warn('Clerk is not available. Falling back to noop auth adapter.');
        return noopAuthAdapter;
    }
    return useClerkAuthAdapter();
}
function useClerkAuthAdapter() {
    const { isLoaded, isSignedIn, user: clerkUser } = useUser();
    const clerk = useClerk();
    const user = useMemo(() => {
        if (!clerkUser)
            return null;
        return {
            id: clerkUser.id,
            name: clerkUser.fullName ?? clerkUser.username ?? clerkUser.primaryEmailAddress?.emailAddress,
            email: clerkUser.primaryEmailAddress?.emailAddress,
            username: clerkUser.username ?? clerkUser.primaryEmailAddress?.emailAddress,
        };
    }, [clerkUser]);
    const signIn = useCallback(async () => {
        await clerk.openSignIn({ redirectUrl: window.location.href });
    }, [clerk]);
    const signOut = useCallback(async () => {
        window.sessionStorage.setItem(SIGN_OUT_TOAST_KEY, JSON.stringify({ message: 'Signed out', type: 'success' }));
        try {
            await clerk.signOut({ redirectUrl: window.location.href });
        }
        catch (error) {
            window.sessionStorage.removeItem(SIGN_OUT_TOAST_KEY);
            throw error;
        }
    }, [clerk]);
    return {
        isLoaded,
        isSignedIn: isLoaded ? !!isSignedIn : false,
        user,
        signIn,
        signOut,
    };
}
